import React from 'react';
import useAuthentication from 'src/hooks/useAuthentication';
export const TaggedCustomerName = () => {
    const { user } = useAuthentication();
    return (user?.customerDisplayName || user?.customerInternalName ? (<span className={`d-none`} data-test-id="tagged-customer-name" id="tagged-customer-name">
                {user?.customerDisplayName || user?.customerInternalName}
            </span>) : null);
};
